
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface DialogData {
  type: 'warning' | 'error' | 'success' | 'info' | 'confirmation';
  title: string;
  subtitle?: string;
  yesButtonText?: string;
  noButtonText?: string;
}

@Component({
    selector: 'app-zignflix-dialog',
    imports: [
      MatButtonModule,
      MatIconModule
    ],
    templateUrl: './zignflix-dialog.component.html',
    styleUrl: './zignflix-dialog.component.scss'
})
export class ZignflixDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ZignflixDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  get iconName(): string {
    switch (this.data.type) {
      case 'success':
        return 'check';
      case 'warning':
        return 'priority_high';
      case 'info':
        return 'info';
      case 'confirmation':
        return 'help_outline';
      case 'error':
      default:
        return 'error_outline';
    }
  }

  get statusLabel(): string {
    switch (this.data.type) {
      case 'success':
        return 'Success';
      case 'warning':
        return 'Attention required';
      case 'info':
        return 'Information';
      case 'confirmation':
        return 'Please confirm';
      case 'error':
      default:
        return 'Something went wrong';
    }
  }
}
